/**
 * Minimal inline sparkline chart for KPI trend visualization.
 * No axes, grid, tooltip, or legend — just a clean area line.
 */

import { Area, AreaChart, ResponsiveContainer } from "recharts";

type SparklineChartProps = {
  readonly data: ReadonlyArray<number>;
  readonly color?: string;
  readonly height?: number;
  readonly width?: number;
};

type DataPoint = { readonly v: number };

function toDataPoints(data: ReadonlyArray<number>): DataPoint[] {
  return data.map((v) => ({ v }));
}

export function SparklineChart({
  data,
  color = "#111111",
  height = 40,
}: SparklineChartProps): React.JSX.Element {
  const points = toDataPoints(data);

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart
        data={points}
        margin={{ top: 2, right: 2, bottom: 2, left: 2 }}
      >
        <Area
          type="monotone"
          dataKey="v"
          stroke={color}
          strokeWidth={1.5}
          fill={color}
          fillOpacity={0.08}
          dot={false}
          isAnimationActive={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
